var _ellipse, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScribblesSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 118,
    viewBox: "0 0 182 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84,
    cy: 77.5,
    rx: 84,
    ry: 21.5,
    fill: "url(#paint0_radial)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.776 56.6128C166.925 85.6613 130.675 79.7914 81.709 83.4694C32.7432 87.1473 9.7619 86.5389 8.37953 68.1349C6.99715 49.7308 27.9618 23.491 76.9276 19.813C125.893 16.1351 145.808 44.7136 161.776 56.6128Z",
    fill: "url(#paint1_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74812 62.4107C5.47667 77.5896 6.34639 82.3561 33.3464 82.8389C60.3465 83.3218 85.7629 96.6562 86.0343 81.4773C86.3058 66.2984 80.2096 44.6408 53.2096 44.1579C26.2095 43.6751 6.01957 47.2317 5.74812 62.4107Z",
    fill: "url(#paint2_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.803 92.7437L138.795 89.6759C138.795 89.6759 135.05 86.5311 135.206 84.5216C135.403 81.9844 141.576 79.7631 141.576 79.7631L154.997 82.4754C154.997 82.4754 158.145 86.6253 157.225 89.0869C156.483 91.0714 152.803 92.7437 152.803 92.7437Z",
    fill: "#767676"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.734 46.6375C164.075 45.388 158.659 44.6875 149 43.4379C146.209 41.9631 143.342 40.7554 140.638 40.1386C136.266 39.141 130.968 39.3796 125.933 40.1087C125.933 40.1087 104.5 31.5 103.779 33.8412C103.059 36.1824 108.114 46.1339 108.114 46.1339L106.347 68.0207C107.959 79.7597 126.312 90.5303 130.656 91.2651C135 92 154.893 88.9159 160.321 79.0087L165.212 57.2309C165.212 57.2309 183.393 47.887 173.734 46.6375Z",
    fill: "url(#paint3_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.582 72.023C149.288 73.5043 147.386 71.5874 144.677 71.05C141.969 70.5126 139.3 73.9912 139.594 72.51C139.888 71.0288 142.341 68.6352 145.05 69.1726C147.758 69.71 149.876 70.5418 149.582 72.023Z",
    fill: "#3D3D3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.239 70.715C128.082 72.2169 126.811 68.4803 124.065 68.1929C121.318 67.9056 118.935 69.1745 119.092 67.6726C119.249 66.1707 121.517 66.002 124.264 66.2893C127.01 66.5767 128.396 69.2131 128.239 70.715Z",
    fill: "#3D3D3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.94 81.5384C132.283 82.0872 133.049 82.1703 133.502 81.7079L136.915 78.224C137.499 77.6276 137.138 76.6202 136.308 76.5301L130.31 75.8793C129.48 75.7893 128.912 76.6959 129.354 77.4037L131.94 81.5384Z",
    fill: "#C5AAAA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M142.841 51.4605L144 41L148.5 43L142.841 51.4605Z",
    fill: "#676767"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.855 49.5963L126 40L130.5 39.6468L129.855 49.5963Z",
    fill: "#676767"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.894 62.2925L142.5 40.5C142.5 40.5 139.966 39.7524 137.787 39.4265C135.609 39.1006 131.767 39.3773 131.767 39.3773L134.894 62.2925Z",
    fill: "#676767"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67749 70.1853C9.33027 66.6904 13.5033 65.1971 16.9982 66.8499C31.9135 73.9036 72.4315 87.9416 115.562 76.2449C119.294 75.233 123.139 77.4375 124.15 81.1687C125.162 84.8999 122.958 88.7449 119.227 89.7568C71.534 102.691 27.3791 87.2458 11.0129 79.506C7.51803 77.8532 6.02471 73.6802 7.67749 70.1853Z",
    fill: "url(#paint4_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.929 74.1016L20.1062 83.2173L25.0289 84.8808L25.929 74.1016Z",
    fill: "#676767"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2325 84.317L39.704 74.9862L34.7215 73.5114L34.2325 84.317Z",
    fill: "#676767"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6362 76.1106L22 69L18 67.5L14.6362 76.1106Z",
    fill: "#676767"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5729 88.759L58.6034 78.7213L53.4575 78L54.5729 88.759Z",
    fill: "#676767"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6781 91.6555L80 81L74 80.5L76.6781 91.6555Z",
    fill: "#676767"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0892 90.7653L96.5 80L92 80.5L96.0892 90.7653Z",
    fill: "#676767"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2401 80.5383L41.5 90L46.2401 91L46.2401 80.5383Z",
    fill: "#676767"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5785 83.0552L62.1099 93.3006L67.2878 93.736L65.5785 83.0552Z",
    fill: "#676767"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4035 84.343L85.5 94.7234L90 94.5L87.4035 84.343Z",
    fill: "#676767"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M160.29 35.321L165.902 36.5474L166.284 34.7989L163.636 34.2203L163.643 34.187L166.894 31.5298L167.199 30.131L161.787 28.9483L161.405 30.6968L164.103 31.2864L164.096 31.3197L160.566 34.0555L160.29 35.321Z",
    fill: "#A5B4FC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M173.447 27.2852L179.06 26.0639L178.68 24.315L176.031 24.8913L176.024 24.858L177.873 21.0889L177.568 19.6898L172.155 20.8677L172.536 22.6166L175.234 22.0294L175.241 22.0627L173.172 26.0194L173.447 27.2852Z",
    fill: "#A5B4FC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M165.36 10.6302L170.285 13.5872L171.206 12.0527L168.883 10.6576L168.9 10.6284L172.83 9.15042L173.567 7.92288L168.817 5.0712L167.896 6.60563L170.263 8.02708L170.246 8.05631L166.027 9.51955L165.36 10.6302Z",
    fill: "#A5B4FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 130.28,
    y: 75.5178,
    width: 32.2246,
    height: 22.9753,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84 77.5) rotate(90) scale(21.5 84)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 77.9498,
    y1: 19.7362,
    x2: 93.4233,
    y2: 86.9731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 57.7646,
    y1: 91.4496,
    x2: 45.7278,
    y2: 45.5169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#747373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#919191"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 138.842,
    y1: 39.7849,
    x2: 131.009,
    y2: 91.9649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#868686"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 8.8641,
    y1: 71.2365,
    x2: 124.677,
    y2: 79.5057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#7D7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E9C9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScribblesSleep);
export default __webpack_public_path__ + "static/media/scribbles-sleep.f0bf15f95e5565d23ae82086b85125d2.svg";
export { ForwardRef as ReactComponent };